// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 511) return "static/chunks/511.fd391778fa973a5d.js";
	if (chunkId === 942) return "static/chunks/942.7af46a0e0afa2686.js";
	if (chunkId === 827) return "static/chunks/827.818990f3a1a2ba20.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 684 ? "72e3b1d9" : chunkId) + "-" + {"201":"bece53bfc704cb05","613":"48f8fb5e4af37732","684":"90622a96f4cba4a8","856":"9bc38e1291b546c8","879":"88b33f702d77dccb","957":"3b738488bd863338","965":"effa1d5cc25e9f89"}[chunkId] + ".js";
};